export const isProduction = ['stake-portal.vercel.app', import.meta.env.VITE_DOMAIN]
    .filter(Boolean)
    .includes(location.host);

export const isIos = /ios|iphone/i.test(navigator.userAgent);
export const isAndroid = /android/i.test(navigator.userAgent);
export const isMobile = isIos || isAndroid;
